__turbopack_context__.v({
  "icon": "eEl-1a_icon",
  "root": "eEl-1a_root",
});
